module.exports = __webpack_public_path__ + "static/media/mitarbeiter_true_active.b032c8b9.jpg";